import { ObjectReducer, mergeEntity } from '../../store';

import { transformNavigationUserInfo } from './transformers';

export const navigationUserInfoReducer: ObjectReducer<'navigationUserInfo'> = (
  state = {},
  action,
) => {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (
        action.payload &&
        action.payload.ref.path[0] === 'navigationUserInfo'
      ) {
        const { data, ref } = action.payload;
        return mergeEntity<'navigationUserInfo'>(
          state,
          transformNavigationUserInfo(data),
          ref.path,
        );
      }
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/navigation/reducers/userInfo.ts